<template>
  <div class="container">
    <div class="result">
      <h2>我的报名</h2>
      <p>您已报名成功！</p>
      <p>请仔细阅读报名页面的【报名必读】</p>
      <p class="phone">咨询方式：<a href="javascript:;">0351-8789188</a></p>
      <p class="listTitle">查询到{{ result.total }}条符合条件的数据</p>
      <div class="listData" v-for="item of result.records" :key="item.id">
        <div>
          <span>活动场次：</span>
          <span>{{ item.ownedActivity_dictText }}<button @click="cancel(item)">取消报名</button></span>
        </div>
        <div>
          <span>姓<i class="box"></i>名：</span>
          <span>{{ item.name }}</span>
        </div>
        <div style="border-bottom: 0">
          <span>手机号码：</span>
          <span>{{ item.contact }}</span>
        </div>
      </div>
      <div class="btn">
        <van-button color="#7A726C" text="返回" @click="back" />
      </div>
      <div class="tip">
        <span>*注意：如果三次未签到，您将无法报名本年度其他活动</span>
      </div>
    </div>
  </div>
</template>

<script>
import { querySignResultByPhone, postActivities } from '@/api/culturalRelic'
export default {
  name: 'myResule',
  data: () => ({
    result: {}
  }),
  created () {
    this.queryResult()
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    async queryResult () {
      console.log(this.$route.query)
      const { result } = await querySignResultByPhone({
        phone: this.$route.query.phone,
        activityId: this.$route.query.activityId
      })
      console.log(result)
      this.result = result
    },
    async cancel (item) {
      console.log(item)
      const { result } = await postActivities(item.id)
      this.$toast.success('取消报名成功')
      this.queryResult()
      console.log(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: #F7EEE8 url(../../../assets/bg-bj@2x.png) no-repeat top center / 100%;
  overflow: hidden;
  font-family: 'PingFangMedium';
  .result {
    width: 300px;
    background: #EFDFCB;
    border-radius: 8px;
    margin: /*300px*/
      40vh auto 100px;
    overflow: hidden;
    position: relative;
    h2 {
      width: 100%;
      font-size: 17px;
      font-weight: 400;
      color: #7A726C;
      text-align: center;
      box-sizing: border-box;
      margin:0;
      padding: 10px 0;
      background-color: #CDC0AA;
    }
    .box {
      margin: 0 12px;
    }
    p {
      width: 100%;
      color: #7A726C;
      font-size: 14px;
      font-weight: 500;
      padding: 0 17px 5px;
      text-align: center;
      box-sizing: border-box;
      margin: 0 0 5px;
      &:nth-of-type(1) {
        margin-top: 20px;
      }
    }

    .phone {
      width: 100%;
      padding-bottom: 11px;
      border-bottom: 1px solid rgba(217, 193, 155, 0.5);
      margin-bottom: 16px;
      box-sizing: border-box;
      a {
        color: #485349;
        font-family: 'PingFangBold';
        font-weight: 900;
      }
    }

    .listTitle {
      margin-top: 16px;
      margin-bottom: 12px;
      font-weight: 400;
      color: #333333;
      font-size: 14px;
    }

    .listData {
      margin: 10px 17px;
      background: #E7D8BF;
      border: 1px solid #E7D8BF;
      border-bottom: 0;
      border-radius: 5px;
      overflow: hidden;
      > div {
        position: relative;
        min-height: 25px;
        border-bottom: 1px dashed #D9C19B;
        span {
          display: inline-block;
          padding: 5px 11px;
          box-sizing: border-box;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          //height: 30px;
          &:nth-child(1) {
            width: 30%;
            height: 100%;
            //border-right: 1px solid #202020;
            //border-bottom: 1px solid #202020;
            white-space: nowrap;
            vertical-align: middle;
            font-size: 12px;
            text-align: right;
            padding-right: 0;
          }

          &:nth-child(2) {
            width: 54%;
            height: 100%;
            border-left: 1px dashed #D9C19B;
            vertical-align: middle;
            //border-bottom: 1px solid #202020;
            i {
              display: inline-block;
              width: 70%;
              font-style:normal;
              word-break:break-all;
            }
            button {
              position: absolute;
              right: 0;
              top: 0;
              line-height: 1.5;
              background-color: #7A726C;
              border: 0;
              text-align: center;
              border-radius: 2px;
              //height: 100%;
              padding: 2px 5px;
              padding-top: 4px;
              color: #fff;
              transform:scale(0.8);
            }
          }
        }
      }
    }

    .tip {
      font-size: 13px;
      font-weight: 400;
      color: #7A726C;
      margin: 0 22px;
      text-align: left;
      line-height: 1.5;
      span {
        display: block;
        margin: 10px 0;
      }
    }
    .btn {
      width: 100%;
      text-align: center;
      margin-bottom: 13px;
      margin-top: 20px;
      .van-button {
        min-width: 200px;
        height: 40px;
        border-radius: 7px;
      }
    }
  }
}
</style>
